import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_ENDPOINTS, buildApiUrl } from '../../constants/apiendpoints.constant';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TechnicalGuideService {
  constructor(private http: HttpClient) { }

  getTechnicalGuidePageData(): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.TECHNICAL_GUIDE.GET_TECHNICAL_GUIDE_PAGE_DATA) + '?infoType=guide_details';
    return this.http.get<any>(appURL).pipe((data) => data, catchError(this.handleError));
   }

   public handleError(err: HttpErrorResponse) {
    let errMsg: any;
    if (err instanceof Error) {
      errMsg = err.message;
    } else {
      errMsg = err.status;
    }
    return throwError(errMsg);
   }
}
